import React from "react";

const benefits = [
  { stat: "90%", label: "faster rent collection", text: "Automated reminders mean tenants pay on time, every time." },
  { stat: "3 min", label: "to set up a property", text: "Add a building, assign tenants, and start tracking with no training needed." },
  { stat: "0", label: "missed payments", text: "Arrears carry forward automatically. Nothing slips through the cracks." },
  { stat: "24/7", label: "AI follow up", text: "The AI voice agent calls tenants even when you're busy." },
];

export default function BenefitsSection() {
  return (
    <section className="border-b border-gray-100 bg-gray-50 py-16 dark:border-gray-800 dark:bg-gray-900 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wide text-indigo-600 dark:text-indigo-400">
            Benefits
          </span>
          <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
            Why landlords love Paysafi
          </h2>
        </div>
        <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {benefits.map((b) => (
            <div key={b.label} className="text-center">
              <div className="text-4xl font-bold text-indigo-600 dark:text-indigo-400">{b.stat}</div>
              <div className="mt-1 text-sm font-semibold uppercase tracking-wide text-gray-900 dark:text-white">
                {b.label}
              </div>
              <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">{b.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
